const config = () => {
  const personaVars = {
    PERSONA_PROD_ENVIRONMENT_ID: 'env_eTaPsnq9TRTB4jkkksr1myYXb4dN',
    PERSONA_SANDBOX_ENVIRONMENT_ID: 'env_K7PmhWdJWKpUgP3xcTMEkGLo8675',
    PERSONA_TEMPLATE_ID_ID_VERIFICATION: 'itmpl_RxdXwtQeMGp7N76b3QGBahChW42w',
    PERSONA_TEMPLATE_ID_LISTING_VERIFICATION_CLASSIFIED: 'itmpl_z83AuuNyJ6hSpu9NvLpzaWywHzc4',
    PERSONA_TEMPLATE_ID_LISTING_VERIFICATION_UNCLASSIFIED: 'itmpl_WmtjS4F8a4xvddovepF54qsdWDLA',
    PERSONA_TEMPLATE_ID_EMPLOYMENT_VERIFICATION_CLASSIFIED: 'itmpl_SYp5rvgptfJes2xHGSusnUDCvWDF',
    PERSONA_TEMPLATE_ID_EMPLOYMENT_VERIFICATION_UNCLASSIFIED: 'itmpl_jjgWcXxyU1yZGH4ujzwey63YuoCe',
    PERSONA_TEMPLATE_ID_INCOME_VERIFICATION_CLASSIFIED: 'itmpl_nkf62RgV4GY8X4BsREhaKGYoCQky',
    PERSONA_TEMPLATE_ID_INCOME_VERIFICATION_UNCLASSIFIED: 'itmpl_bzaeqTKgfHVd4hz7oLsortVbEFd3'
  }
  const defaultVars = {
    LINKEDIN_CLIENT_ID: '86woo29flgg5xm',
    ...personaVars
  }

  const envs = {
    test: {},
    dev: {
      ...defaultVars,
      BACKEND_SERVER: import.meta.env.VITE_BACKEND_SERVER || 'https://be-dev2.machobear.ca',
      GRAPHQL_SERVER:
        import.meta.env.VITE_GRAPHQL_SERVER || 'https://nemesis-dev.machobear.ca/graphql',
      WEB_URL: import.meta.env.VITE_WEB_URL || 'https://trustliv-dev.machobear.ca',
      STRIPE_TOKEN: 'pk_test_ZXncuS0lYHorcgjP3FaM1DXY',
      APP_PATH: import.meta.env.BASE_URL.replace(/\/$/, '') || '',
      IMAGES_URL: 'https://cdn-dev.machobear.ca',
      VIDEOS_URL: 'https://cdn-dev-videos.machobear.ca',
      NCHAN_SERVER: import.meta.env.VITE_NCHAN_SERVER || 'https://nchan-dev2.machobear.ca/sse',
      MAP_SERVER: 'https://maps-dev.liv.rent',
      FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID || '144273570564908'
    },
    dev2: {
      ...defaultVars,
      BACKEND_SERVER: import.meta.env.VITE_BACKEND_SERVER || 'https://chaos2-dev.machobear.ca',
      GRAPHQL_SERVER:
        import.meta.env.VITE_GRAPHQL_SERVER || 'https://nemesis-dev.machobear.ca/graphql',
      WEB_URL: 'https://trustliv2-dev.machobear.ca',
      STRIPE_TOKEN: 'pk_test_ZXncuS0lYHorcgjP3FaM1DXY',
      APP_PATH: import.meta.env.BASE_URL.replace(/\/$/, '') || '',
      IMAGES_URL: 'https://cdn-dev.machobear.ca',
      VIDEOS_URL: 'https://cdn-dev-videos.machobear.ca',
      NCHAN_SERVER: import.meta.env.VITE_NCHAN_SERVER || 'https://nchan-dev2.machobear.ca/sse',
      MAP_SERVER: 'https://maps-dev.liv.rent',
      FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID || '144273570564908'
    },
    dev3: {
      ...defaultVars,
      BACKEND_SERVER: import.meta.env.VITE_BACKEND_SERVER || 'https://be-dev2.machobear.ca',
      GRAPHQL_SERVER:
        import.meta.env.VITE_GRAPHQL_SERVER || 'https://nemesis-dev.machobear.ca/graphql',
      WEB_URL: 'https://trustliv3-dev.machobear.ca',
      STRIPE_TOKEN: 'pk_test_ZXncuS0lYHorcgjP3FaM1DXY',
      APP_PATH: import.meta.env.BASE_URL.replace(/\/$/, '') || '',
      IMAGES_URL: 'https://cdn-dev.machobear.ca',
      VIDEOS_URL: 'https://cdn-dev-videos.machobear.ca',
      NCHAN_SERVER: import.meta.env.VITE_NCHAN_SERVER || 'https://nchan-dev2.machobear.ca/sse',
      MAP_SERVER: 'https://betacdn.liv.rent',
      FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID || '144273570564908'
    },
    stg: {
      ...defaultVars,
      BACKEND_SERVER: import.meta.env.VITE_BACKEND_SERVER || 'https://be-stg.machobear.ca',
      GRAPHQL_SERVER: import.meta.env.VITE_GRAPHQL_SERVER,
      WEB_URL: 'https://kratos-stg.machobear.ca',
      STRIPE_TOKEN: 'pk_test_ZXncuS0lYHorcgjP3FaM1DXY',
      APP_PATH: import.meta.env.BASE_URL.replace(/\/$/, '') || '',
      IMAGES_URL: 'https://d3j1zuo7506rra.cloudfront.net',
      NCHAN_SERVER: import.meta.env.VITE_NCHAN_SERVER || 'https://nchan-dev2.machobear.ca/sse',
      MAP_SERVER: 'https://maps-dev.liv.rent',
      FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID || '144273570564908'
    },
    demo: {
      ...defaultVars,
      BACKEND_SERVER: import.meta.env.VITE_BACKEND_SERVER || 'https://be-demo.machobear.ca',
      GRAPHQL_SERVER: import.meta.env.VITE_GRAPHQL_SERVER,
      STRIPE_TOKEN: 'pk_test_ZXncuS0lYHorcgjP3FaM1DXY',
      APP_PATH: import.meta.env.BASE_URL.replace(/\/$/, '') || '',
      NCHAN_SERVER: import.meta.env.VITE_NCHAN_SERVER || 'https://nchan-dev2.machobear.ca/sse',
      MAP_SERVER: 'https://maps-dev.liv.rent',
      FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID || '144273570564908'
    },
    qa: {},
    prod: {
      ...defaultVars,
      BACKEND_SERVER: import.meta.env.VITE_BACKEND_SERVER || 'https://be-prod.liv.rent',
      GRAPHQL_SERVER:
        import.meta.env.VITE_GRAPHQL_SERVER || 'https://nemesis-prod.liv.rent/graphql',
      WEB_URL: 'https://liv.rent',
      STRIPE_TOKEN: import.meta.env.VITE_STRIPE_TOKEN,
      APP_PATH:
        typeof import.meta.env.BASE_URL.replace(/\/$/, '') === 'undefined'
          ? '/app'
          : import.meta.env.BASE_URL.replace(/\/$/, ''),
      IMAGES_URL: 'https://cdn.liv.rent',
      VIDEOS_URL: 'https://cdn-videos.liv.rent',
      NCHAN_SERVER: import.meta.env.VITE_NCHAN_SERVER || 'https://sse.liv.rent/sse',
      MAP_SERVER: process.env.NEXT_PUBLIC_MAPS_SERVER || 'https://maps.liv.rent',
      FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID
    }
  }

  const targetEnv = import.meta.env.VITE_BUILD_ENV || 'dev'
  const conf = {
    ...envs[targetEnv],
    BUILD_ENV: targetEnv
  }

  return conf
}

export default config()
